module.exports = __webpack_public_path__ + "static/media/ogl.add0c25e.svg";